import { useSetAtom } from 'jotai';
import { useEffect } from 'react';

import { isRequirementsPageAtom } from '../data-access/atoms/requirements.atom';

/**
 * Hook to set the isRequirementsPageAtom to true when the Requirements Page mounts and to false when it unmounts
 */
export const useIsRequirementsPageSetter = () => {
	const setIsRequirementsPage = useSetAtom(isRequirementsPageAtom);

	useEffect(() => {
		setIsRequirementsPage(true);

		return () => {
			setIsRequirementsPage(false);
		};
	}, []);
};
